import InsureProcessBuildingInfo from './InsureProcessBuildingInfo';
export default InsureProcessBuildingInfo;
